import React from 'react';
import { TableCell, TableCellProps } from '@material-ui/core';

const MyTableCell: React.FC<TableCellProps> = props => {
  const { children, ...rest } = props;
  return <TableCell {...rest}>{children}</TableCell>;
};

export default MyTableCell;
